module.exports = __webpack_public_path__ + "img/logo.2bc1ea59.svg";